import React, { useState, useEffect, useContext } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";
import { logActivity } from "../../utils/LogActivity";
import { Authorization } from "../../Context/Authorization";
const AddDivision = ({ onClose, onAddDivision }) => {
  const [divisionName, setDivisionName] = useState("");
  const [divisionCode, setDivisionCode] = useState("");
  const [circleId, setCircleId] = useState("");
  const [circle, setCircle] = useState([]);
  const [errors, setErrors] = useState({});
  const { access, userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!divisionName) {
      newErrors.divisionName = "Division name is required";
    }
    if (!divisionCode) {
      newErrors.divisionCode = "Division code is required";
    }
    if (!circleId) {
      newErrors.circleId = "Please select Circle Id";
    }
    return newErrors;
  };

  useEffect(() => {
    setLoading(true);
    const fetchCircle = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/circles`, config);
        const data = response.data;
        if (Array.isArray(data)) {
          setCircle(data);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };

    fetchCircle();
  }, [access]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fill all Details");
      return;
    }

    const formData = {
      divisionName,
      divisionCode,
      circleId,
    };

    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/divisions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...config.headers,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        toast.success("Added Successfully");
        onAddDivision(result);
        await logActivity(
          userId,
          "New Division Added",
          "Add Dicision Page",
          Api
        );
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
      setLoading(false);
    }
    setLoading(false);
  };
  return (
    <div>
      <Preloader loading={loading} />
      <Modal show onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Add Division</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formDivisionName">
              <Form.Label>
                Division Name<span className="required-asterisk">*</span>
              </Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter Division name"
                  value={divisionName}
                  onChange={(e) => setDivisionName(e.target.value)}
                  isInvalid={!!errors.divisionName}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.divisionName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formDivisionCode">
              <Form.Label>
                Division Code<span className="required-asterisk">*</span>
              </Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter Division Code"
                  value={divisionCode}
                  onChange={(e) => setDivisionCode(e.target.value)}
                  isInvalid={!!errors.divisionCode}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.divisionCode}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formStateId">
              <Form.Label>
                Circle ID<span className="required-asterisk">*</span>
              </Form.Label>
              <div className="input-container">
                <Form.Control
                  as="select"
                  value={circleId}
                  onChange={(e) => setCircleId(e.target.value)}
                  isInvalid={!!errors.divisionCode}
                >
                  <option value="">Select Circle</option>
                  {circle.map((cir) => (
                    <option key={cir._id} value={cir._id}>
                      {cir.circleCode}
                    </option>
                  ))}
                </Form.Control>
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.circleCode}
              </Form.Control.Feedback>
            </Form.Group>
            <button
              type="submit"
              className="btn btn-outline-primary btn-icon-text mt-3"
            >
              <i className="mdi mdi-file-check btn-icon-prepend"></i>
              Submit
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddDivision;
